/**
 * HoldPage — Reservas en HOLD (esperando pago / confirmación).
 */
import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Box, Typography, Alert, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ReservacionesTable from './shared/ReservacionesTable';
import ReservaSlideOver from './ReservaSlideOver';
import { categorizar } from './shared/useReservaciones';
import { todayLocal } from './shared/format';
import { exportarReservasCSV } from './shared/exportCSV';

export default function HoldPage() {
  const { reservaciones, isLoading, refetch } = useOutletContext();
  const [detalleId, setDetalleId] = useState(null);

  const { hold } = categorizar(reservaciones);

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
        <Box>
          <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>Reservas en HOLD</Typography>
          <Typography sx={{ fontSize: 12, color: '#64748b' }}>
            {hold.length} {hold.length === 1 ? 'reserva' : 'reservas'} esperando confirmación / pago.
          </Typography>
        </Box>
        <Button variant="outlined" startIcon={<DownloadIcon />} size="small"
          disabled={hold.length === 0}
          onClick={() => exportarReservasCSV(hold, `reservas-hold-${todayLocal()}.csv`)}
          sx={{ textTransform: 'none', fontWeight: 600, color: '#0f766e', borderColor: '#0f766e' }}>
          CSV ({hold.length})
        </Button>
      </Box>

      <Alert severity="info" sx={{ mb: 1.5, fontSize: 12 }}>
        Las reservas en HOLD se confirman cuando llega el pago (webhook Bold o registro manual).
        El scheduler libera los cupos automáticamente si pasan más de 30 min sin pago.
      </Alert>

      <ReservacionesTable
        rows={hold}
        loading={isLoading}
        onRowClick={r => setDetalleId(r.id)}
        emptyTitle="Sin reservas en HOLD"
        emptyMessage="Cuando una reserva quede pendiente de pago, aparecerá aquí."
      />

      {detalleId && (
        <ReservaSlideOver reservaId={detalleId}
          onClose={() => setDetalleId(null)} onUpdated={refetch} />
      )}
    </Box>
  );
}
